import { MetaActionTypes } from './actions';

export function clearState(reducer) {
    return (state, action) => {

      if (action.type === MetaActionTypes.LOGOUT) {
        state = undefined;
      }
      return reducer(state, action);
    };
  }
